export const languages = [
  {
    icon: 'devicon-javascript-plain colored',
    value: 'JavaScript',
  },
  {
    icon: 'devicon-html5-plain colored',
    value: 'HTML',
  },
  {
    icon: 'devicon-css3-plain colored',
    value: 'CSS',
  },
  {
    icon: 'devicon-ruby-plain colored',
    value: 'Ruby',
  },
  {
    icon: 'devicon-python-plain colored',
    value: 'Python',
  },
  {
    icon: 'devicon-java-plain colored',
    value: 'Java',
  },
];

export const skills = [
  {
    icon: 'devicon-react-original colored',
    value: 'React.js',
  },
  {
    icon: 'devicon-rails-plain colored',
    value: 'Ruby on Rails',
  },
  {
    icon: 'devicon-express-original colored',
    value: 'Express.js',
  },
  {
    icon: 'devicon-jquery-plain colored',
    value: 'jQuery',
  },
  {
    icon: 'devicon-bootstrap-plain colored',
    value: 'Bootstrap',
  },
  {
    icon: 'devicon-nodejs-plain colored',
    value: 'Node.js',
  },
];

export const technologies = [
  {
    icon: 'devicon-github-plain colored',
    value: 'Github',
  },
  {
    icon: 'devicon-heroku-plain colored',
    value: 'Heroku',
  },
  {
    icon: 'devicon-amazonwebservices-original colored',
    value: 'Amazon Web Services',
  },
  {
    icon: 'devicon-vim-plain colored',
    value: 'Vim',
  },
  {
    icon: 'devicon-atom-plain colored',
    value: 'Atom',
  },
  {
    icon: 'devicon-visualstudio-plain colored',
    value: 'VSCode',
  },
];



// WEBPACK FOOTER //
// ./src/data/SkillsData.js